import { useEffect, useState } from 'react';

/**
 * Shared mobile breakpoint (max-width 767px) used to switch between the
 * desktop and mobile variants of the journey and application chrome. Keep the
 * query in sync with the `@media (min-width: 768px)` block in styles.css.
 */
export function useIsMobile(): boolean {
  const query = '(max-width: 767px)';
  const [mobile, setMobile] = useState(
    () => typeof window.matchMedia === 'function' && window.matchMedia(query).matches,
  );
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setMobile(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return mobile;
}
